const API_STACK = 'review/';

export const GET_REVIEW = API_STACK + 'provider/:providerUuid';
